import { useLocation } from 'react-router-dom'
import { observer } from 'mobx-react'

import { NewJoinerLogin } from 'Modules/auth/components/NewJoinerLogin/NewJoinerLogin'
import { PasswordlessError } from 'Modules/auth/components/PasswordlessError/PasswordlessError'
import { PortalLogin } from 'Modules/auth/components/PortalLogin/PortalLogin'
import { AuthRoutePathsEnum } from 'Modules/auth/routes/authRouteConfig.types'

import { useStore } from 'Stores/index'
import { UserModeEnum } from 'Stores/portalSettingsStore/portalSettingsStore.types'

export const Login = observer(() => {
  const { portalSettingsStore } = useStore()
  const { userMode } = portalSettingsStore

  const location = useLocation()

  const isPasswordless = location.pathname.includes(
    AuthRoutePathsEnum.PASSWORDLESS_LOGIN,
  )

  const isPasswordlessError = location.pathname.includes(
    AuthRoutePathsEnum.PASSWORDLESS_LOGIN_ERROR,
  )

  if (window.location.href.includes('tokenLoginFailed=1')) {
    window.location.replace(
      `${window.location.origin}${window.location.pathname}#/${AuthRoutePathsEnum.PASSWORDLESS_LOGIN_ERROR}`,
    )
  }

  if (isPasswordlessError) {
    return <PortalLogin customLoginContent={<PasswordlessError />} />
  }

  if (userMode === UserModeEnum.NEW_JOINER) {
    return <NewJoinerLogin isPasswordless={isPasswordless} />
  }

  return <PortalLogin />
})
